import BillingInformation from './BillingInformation';
import MyAccount from './MyAccount';
import AccountCompanySection from './AccountCompanySection';
import Subscription from './Subscription';

import UseModal from 'hooks/use-modal';
import Modal from '@core/components/Modal/Modal';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import { UserOctagon } from 'iconsax-react';
import BillingInfoIcon from 'assets/icons/billing-info-icon.svg';
import UserIcon from 'assets/icons/user-icon.svg';
import CompanyIcon from 'assets/icons/home-hashtag.svg';

import classes from './MobileSettings.module.scss';

const MobileSettings = ({ isBusiness = false }) => {
	const {
		show: showNotification,
		destroyModal: destroyNotificationModal,
		showModal: showNotificationModal
	} = UseModal();

	const {
		showModal: showAccountHandler,
		destroyModal: destroyAccountHandler,
		show: showAccount
	} = UseModal();

	const {
		showModal: showBillingInformationHandler,
		destroyModal: destroyBillingInformation,
		show: showBillingInformation
	} = UseModal();

	const {
		showModal: showSubscriptionHandler,
		destroyModal: destroySubscription,
		show: showSubscription
	} = UseModal();


	return (
		<>
			<div className={classes['setting-container']}>


				<button className={classes['setting-item']} onClick={showAccountHandler}>
					<UserIcon />
					<span>My Account</span>
				</button>
				{!isBusiness && (
					<>
						<button className={classes['setting-item']} onClick={() => showSubscriptionHandler()}>
							<UserOctagon />
							<span>Subscription</span>
						</button>
						<button className={classes['setting-item']} onClick={() => showBillingInformationHandler()}>
							<BillingInfoIcon />
							<span>Billing Information</span>
						</button>
					</>
				)}
				{isBusiness && (
					<button className={classes['setting-item']} onClick={() => showNotificationModal()}>
						<CompanyIcon />
						<span>My Company</span>
					</button>
				)}
			</div>
			<Modal
				title="My Account"
				show={showAccount}
				closeHandler={destroyAccountHandler}
				type={MOBILE_FULLSCREEN}>
				<MyAccount />
			</Modal>
			<Modal
				show={showNotification}
				closeHandler={destroyNotificationModal}
				type={MOBILE_FULLSCREEN}
				title="My Company">
				<div className={`${classes['settings-modal']}`}>
					<AccountCompanySection />
				</div>
			</Modal>
			<Modal
				show={showBillingInformation}
				closeHandler={destroyBillingInformation}
				type={MOBILE_FULLSCREEN}
				title="Billing Information">
				<div className={`${classes['settings-modal']}`}>
					<BillingInformation />
				</div>
			</Modal>
			<Modal
				show={showSubscription}
				closeHandler={destroySubscription}
				type={MOBILE_FULLSCREEN}
				title="Subscription">
				<div className={`${classes['settings-modal']}`}>
					<Subscription />
				</div>
			</Modal>
		</>
	);
};

export default MobileSettings;
